export class SessionStatusConstants{
    public static readonly StatusName_Scheduled: string = 'Scheduled';
    public static readonly StatusClassName_Scheduled: string = 'scheduled';
    public static readonly StatusName_Completed : string = 'Completed';
    public static readonly StatusClassName_Completed : string = 'completed';
    public static readonly StatusName_Cancelled: string = 'Cancelled';
    public static readonly StatusClassName_Cancelled: string = 'cancelled';
}